import billingApi from '@/lib/billingApi'

export type MinimumPaymentState = 'none' | 'preparing' | 'processing' | 'activating' | 'requires_action' | 'payment_method_required' | 'needs_support'

export async function confirmExistingPackagePayment(serverUuid: string, expectedAmount?: { minor: number; currency: string }) {
  const response = await billingApi.post<{ data: {
    server_uuid: string; client_secret: string; payment_method_id: string
    amount_minor: number; currency: string
    status: 'requires_action' | 'requires_payment_method' | 'requires_confirmation'
  } }>('/hoard-api/billing/package-minimum-authentication', { server_uuid: serverUuid })
  const pending = response.data.data
  if (pending.server_uuid !== serverUuid || !Number.isInteger(pending.amount_minor) || pending.amount_minor <= 0
    || !/^[a-z]{3}$/.test(pending.currency) || !pending.client_secret || !pending.payment_method_id
    || !['requires_action', 'requires_payment_method', 'requires_confirmation'].includes(pending.status)
    || (expectedAmount && (pending.amount_minor !== expectedAmount.minor || pending.currency !== expectedAmount.currency))) {
    throw new Error('The payment details changed. Please contact support before paying.')
  }
  const key = window.__RUNTIME_CONFIG__?.STRIPE_PUBLISHABLE_KEY
  if (!key || !window.Stripe) throw new Error('Secure payment confirmation is temporarily unavailable.')
  const confirmation = await window.Stripe(key).confirmCardPayment(pending.client_secret,
    pending.status === 'requires_action' ? undefined : { payment_method: pending.payment_method_id })
  if (confirmation.error) throw new Error(confirmation.error.message || 'Your bank could not confirm the payment.')
  if (!['succeeded', 'processing'].includes(confirmation.paymentIntent?.status || '')) {
    throw new Error('Your bank still needs confirmation. Please try again.')
  }
}
